import { inject, injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';
import { IOsiPaymentOrdersWidgetViewModel } from '@shared/types/mobx/widgets/OsiPaymentOrdersWidget';
import moment from 'moment';
import api from '@app/api';
import { notifications } from '@shared/utils/notifications';
import logger from 'js-logger';
import { type OsiService, OsiServiceIdentifier } from '@shared/types/mobx/services/osi';
import { MIME, downloadBase64 } from '@shared/utils/download';

@injectable()
export class OsiPaymentOrdersWidgetViewModel implements IOsiPaymentOrdersWidgetViewModel {
  endDate: any = moment().endOf('month').toDate();

  isLoading = false;

  startDate: any = moment().startOf('month').toDate();

  constructor(@inject(OsiServiceIdentifier) private osiModule: OsiService) {
    makeAutoObservable(this);
  }

  download = async (): Promise<void> => {
    try {
      if (!this.osiModule.osiId) throw new Error('osiId is undefined');

      this.isLoading = true;

      const db = moment.utc(this.startDate).local().format('YYYY-MM-DD[T]HH:mm:ss[Z]');
      const de = moment.utc(this.endDate).local().format('YYYY-MM-DD[T]HH:mm:ss[Z]');
      const data = await api.getPaymentOrdersReport(this.osiModule.osiId, db, de);
      const house = this.osiModule.osiInfo?.address
        ?.split(',')
        .slice(-1)
        .pop()
        ?.replace('д.', '')
        .replace('дом', '')
        .trim();

      const osiName = this.osiModule.osiInfo?.name.startsWith(this.osiModule.osiInfo?.unionTypeRu ?? '')
        ? this.osiModule.osiInfo?.name
        : `${this.osiModule.osiInfo?.unionTypeRu} ${this.osiModule.osiInfo?.name}`;
      // iOS/WebKit: data:-URL не скачивается по атрибуту download — переведено на blob: через downloadBase64
      downloadBase64(
        data as unknown as string,
        MIME.XLSX,
        `Свод_платежных_поручений_${osiName}_дом_${house}_${db.substring(0, 10)}_${de.substring(0, 10)}.xlsx`
      );
    } catch (e) {
      logger.error(e);
      notifications.error();
    } finally {
      this.isLoading = false;
    }
  };
}
